import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useLeaveTypes, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const LeaveTypesPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="leaveTypes"
      hook={useLeaveTypes}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addLeaveType"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="leaveType"
    />
  );
};

export default LeaveTypesPage;
